import Amplify from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import gql from 'graphql-tag';
import {
  PROPERTY_SERVICE_V0_AWS_CONFIG,
  PROPERTY_SERVICE_V2_AWS_CONFIG,
  PROPERTY_SERVICE_V3_AWS_CONFIG,
  PROPERTY_SERVICE_V4_AWS_CONFIG,
  PROPERTY_SERVICE_V5_AWS_CONFIG,
  INTEGRATION_SERVICE_V4_AWS_CONFIG,
  INTEGRATION_SERVICE_V3_AWS_CONFIG,
  INTEGRATION_SERVICE_V1_AWS_CONFIG,
  PROPERTY_SERVICE_V6_AWS_CONFIG,
  INTEGRATION_SERVICE_V10_AWS_CONFIG,
  PROPERTY_SERVICE_V7_AWS_CONFIG,
  PROPERTY_SERVICE_URL,
  SSO_CLIENT_ID,
  SSO_TOKEN_URL,
  X_API_KEY,
} from '../env/Configurations';
import {
  activateAmenity,
  addChef,
  addRestaurant,
  addSpa,
  addSpaTreatment,
  changeRestaurantInfoStatus,
  changeSpaStatus,
  changeSpaTreatmentStatus,
  createAmenitiesCategory,
  createAmenity,
  createGroup,
  createHotel,
  createLocation,
  createSpaCategory,
  dataSortMapping,
  deactivateAmenity,
  deactivateUser,
  deleteAmenity,
  deleteAmenityCategory,
  deleteChef,
  deleteGroup,
  deleteGroupByLanguage,
  deleteHotel,
  deleteHotelLang,
  deleteLocation,
  deleteRestaurant,
  deleteSpa,
  deleteSpaCategory,
  deleteSpaTreatment,
  deleteUser,
  editUser,
  getPreSignedS3Url,
  inviteUserReq,
  reactivateUser,
  resendInvite,
  updateAmenitiesCategory,
  updateAmenity,
  updateChef,
  updateGroup,
  updateGroupWithLanguage,
  updateHotel,
  updateHotelByLanguage,
  updateHotelDeviceModuleState,
  updateHotelUIBuilderState,
  updateLocation,
  updateRestaurant,
  updateSpa,
  updateSpaCategory,
  updateSpaTreatment,
  syncSRS,
  updateSpaSyncConfig,
  syncPOS,
  updateIRDSyncConfig,
  updateHKSyncConfig,
  syncHK,
  updateLiveTvOrder,
  sortChannel,
  createCategorySection,
  updateCategorySection,
  deleteCategorySection,
  syncPreference,
  enableMFAConfig
} from '../graphql/mutations';
import {
  getAccommodationsDetails,
  getAllRestaurant,
  getRestaurantsByHotel,
  getAllUsers,
  getCategoryById,
  getCategoryListWithCounts,
  getCustomRolePermissions,
  getDefaultAdminRoles,
  getFloorDetailsByHotelIdAndFloorId,
  getFloorListByHotelId,
  getGroupById,
  getHotelAmenityDetails,
  getLocations,
  getPropertyDetails,
  getRoomById,
  getRoomListByHotelId,
  getRoomTypeDetailsByHotelIdAndFloorId,
  getRoomTypeListWithCounts,
  getSpaDetails,
  getUserById,
  getUserDetailsById,
  getSyncConfigs,
  getTimeZones,
} from '../graphql/queries';
import { getCurrentJwtToken, getEncodedValue } from './authUtils';
import { decodeJWT } from './RBACUtil';

Amplify.configure({
  ...PROPERTY_SERVICE_V0_AWS_CONFIG,
});

const client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V0_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V0_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV2Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V2_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V2_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV3Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV4Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V4_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V4_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV5Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V5_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V5_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const propertyServiceV6Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V6_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V6_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV4Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V4_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V4_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV3Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV1Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V1_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V1_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV10Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V10_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V10_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const getUser = async (userId) => {
  return await client.query({
    query: gql(getUserById),
    variables: getEncodedValue({
      input: userId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getAllPropertyDetails = async (lang) => {
  return await client.query({
    query: gql(getPropertyDetails),
    variables: getEncodedValue({
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getAllAccommodationsDetails = async (hotelId, lang) => {
  return await client.query({
    query: gql(getAccommodationsDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getAllAmenitiyDetails = async (hotelId, lang) => {
  return await client.query({
    query: gql(getHotelAmenityDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};
export const getAllLocations = async (hotelId, lang) => {
  return await propertyServiceV3Client.query({
    query: gql(getLocations),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};
export const creatNewGroup = async (group, lang) => {
  return await client.mutate({
    mutation: gql(createGroup),
    variables: getEncodedValue({
      code: group.code,
      name: group.name,
      description: group.description,
      customSenderEmail: group.customSenderEmail,
      firebaseToken: group.firebaseToken,
      lang: lang,
    }),
  });
};

export const updateGroupDetails = async (id, group, lang) => {
  return await client.mutate({
    mutation: gql(updateGroup),
    variables: getEncodedValue({
      code: group.code,
      id: id,
      name: group.name,
      description: group.description,
      customSenderEmail: group.customSenderEmail,
      firebaseToken: group.firebaseToken,
      lang: lang,
    }),
  });
};

export const updateGroupLanguage = async (id, group, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(updateGroupWithLanguage),
    variables: getEncodedValue({
      code: group.code,
      groupId: id,
      name: group.name,
      description: group.description,
      customSenderEmail: group.customSenderEmail,
      lang,
    }),
  });
};

export const getGroup = async (id, lang) => {
  return await client.query({
    query: gql(getGroupById),
    variables: getEncodedValue({
      input: id,
      lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const deleteGroupById = async (id) => {
  return await client.mutate({
    mutation: gql(deleteGroup),
    variables: getEncodedValue({
      id: id,
    }),
  });
};

export const deleteGroupLanguage = async (id, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deleteGroupByLanguage),
    variables: getEncodedValue({
      groupId: id,
      lang,
    }),
  });
};

export const createNewHotel = async (hotel, lang) => {
  return await client.mutate({
    mutation: gql(createHotel),
    variables: getEncodedValue({
      brandId: hotel.brandId,
      checkInTime: hotel.checkInTime,
      checkOutTime: hotel.checkOutTime,
      code: hotel.code,
      currency: hotel.currency,
      description: hotel.description,
      groupId: hotel.groupId,
      images: hotel.images,
      information: hotel.information,
      location: hotel.location,
      name: hotel.name,
      phoneNumber: hotel.phoneNumber,
      starRating: hotel.starRating,
      interests: hotel.interests,
      travelType: hotel.travelType,
      features: hotel.features,
      covid19Regulations: hotel.covid19Regulations,
      termsAndConditions: hotel.termsAndConditions,
      cancellationPolicy: hotel.cancellationPolicy,
      dataProtection: hotel.dataProtection,
      privacyLaws: hotel.privacyLaws,
      wcMessage: hotel.WCMessageInput,
      mediaContent: hotel.mediaContent,
      lang: lang,
      detailsCustomAttributes: hotel.detailsCustomAttributes,
      informationCustomAttributes: hotel.informationCustomAttributes,
      MediaContent: hotel.mediaContent,
    }),
  });
};

export const updateHotelDetails = async (id, hotel, lang) => {
  return await client.mutate({
    mutation: gql(updateHotel),
    variables: getEncodedValue({
      id: id,
      brandId: hotel.brandId,
      checkInTime: hotel.checkInTime,
      checkOutTime: hotel.checkOutTime,
      code: hotel.code,
      currency: hotel.currency,
      description: hotel.description,
      groupId: hotel.groupId,
      images: hotel.images,
      features: hotel.features,
      information: hotel.information,
      location: hotel.location,
      name: hotel.name,
      phoneNumber: hotel.phoneNumber,
      starRating: hotel.starRating,
      interests: hotel.interests,
      travelType: hotel.travelType,
      covid19Regulations: hotel.covid19Regulations,
      termsAndConditions: hotel.termsAndConditions,
      cancellationPolicy: hotel.cancellationPolicy,
      dataProtection: hotel.dataProtection,
      privacyLaws: hotel.privacyLaws,
      wcMessage: hotel.WCMessageInput,
      mediaContent: hotel.mediaContent,
      lang: lang,
      detailsCustomAttributes: hotel.detailsCustomAttributes,
      informationCustomAttributes: hotel.informationCustomAttributes,
      mediaContent: hotel.mediaContent,
    }),
  });
};

export const updateHotelDetailsLanguage = async (id, hotel, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(updateHotelByLanguage),
    variables: getEncodedValue({
      hotelId: id,
      brandId: hotel.brandId,
      checkInTime: hotel.checkInTime,
      checkOutTime: hotel.checkOutTime,
      code: hotel.code,
      currency: hotel.currency,
      description: hotel.description,
      groupId: hotel.groupId,
      images: hotel.images,
      features: hotel.features,
      information: hotel.information,
      location: hotel.location,
      name: hotel.name,
      phoneNumber: hotel.phoneNumber,
      starRating: hotel.starRating,
      interests: hotel.interests,
      travelType: hotel.travelType,
      covid19Regulations: hotel.covid19Regulations,
      termsAndConditions: hotel.termsAndConditions,
      cancellationPolicy: hotel.cancellationPolicy,
      dataProtection: hotel.dataProtection,
      privacyLaws: hotel.privacyLaws,
      mediaContent: hotel.mediaContent,
      lang,
    }),
  });
};

export const deleteHotelById = async (id) => {
  return await client.mutate({
    mutation: gql(deleteHotel),
    variables: getEncodedValue({
      id: id,
    }),
  });
};

export const deleteHotelByLanguage = async (id, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deleteHotelLang),
    variables: getEncodedValue({
      hotelId: id,
      lang,
    }),
  });
};

export const updateHotelUIBuilder = async (hotel, status) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateHotelUIBuilderState),
    variables: getEncodedValue({
      id: hotel.id,
      brandId: hotel.brandId,
      groupId: hotel.groupId,
      isUIBuilderEnabled: status,
    }),
  });
};

export const updateHotelDeviceModule = async (hotel, status, endpoint) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(updateHotelDeviceModuleState),
    variables: getEncodedValue({
      id: hotel.id,
      brandId: hotel.brandId,
      groupId: hotel.groupId,
      isDevicesEnabled: status,
      devicesEndpoint: endpoint,
    }),
  });
};

export const getPreSignedUrl = async (input) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(getPreSignedS3Url),
    variables: getEncodedValue({
      input,
    }),
  });
};

export const getCategoriesByHotelId = async (hotelId) => {
  return await client.query({
    query: gql(getCategoryListWithCounts),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getCategoryByIdAndHotelId = async (hotelId, id) => {
  return await client.query({
    query: gql(getCategoryById),
    variables: getEncodedValue({
      hotelId: hotelId,
      categoryId: id,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getRoomTypesByHotelId = async (hotelId) => {
  return await client.query({
    query: gql(getRoomTypeListWithCounts),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getRoomTypeDetailsByHotelIdAndId = async (hotelId, id) => {
  return await client.query({
    query: gql(getRoomTypeDetailsByHotelIdAndFloorId),
    variables: getEncodedValue({
      hotelId: hotelId,
      id: id,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getHotelFloors = async (hotelId) => {
  return await client.query({
    query: gql(getFloorListByHotelId),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getHotelFloodDetails = async (hotelId, id) => {
  return await client.query({
    query: gql(getFloorDetailsByHotelIdAndFloorId),
    variables: getEncodedValue({
      hotelId: hotelId,
      id: id,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getHotelRooms = async (hotelId) => {
  return await client.query({
    query: gql(getRoomListByHotelId),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getRoomByIdAndHotelId = async (hotelId, id) => {
  return await client.query({
    query: gql(getRoomById),
    variables: getEncodedValue({
      hotelId: hotelId,
      id: id,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getPackages = async (hotelId) => {
  return await client.query({
    query: gql(getRoomListByHotelId),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

// start of Amenities API calls
export const createNewAmenity = async (amenity, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createAmenity),
    variables: getEncodedValue({
      categoryIds: amenity.categoryId,
      name: amenity.name,
      description: amenity.description,
      highlights: amenity.highlights,
      hotelId: hotelId,
      information: amenity.information,
      images: amenity.images,
      mediaContent: amenity.mediaContent,
      lang: lang,
      customAttributes: amenity?.customAttributes,
    }),
  });
};

export const updateAmenityDetails = async (amenity, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateAmenity),
    variables: getEncodedValue({
      name: amenity.name,
      id: amenity.id,
      categoryIds: amenity.categoryId,
      description: amenity.description,
      highlights: amenity.highlights,
      hotelId: hotelId,
      information: amenity.information,
      images: amenity.images,
      mediaContent: amenity.mediaContent,
      lang: lang,
      customAttributes: amenity?.customAttributes,
    }),
  });
};

export const deleteAmenityDetail = async (amenityId, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAmenity),
    variables: getEncodedValue({
      id: amenityId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const activateAmenityDetail = async (hotelId, amenityId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(activateAmenity),
    variables: getEncodedValue({
      id: amenityId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const deactivateAmenityDetail = async (hotelId, amenityId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deactivateAmenity),
    variables: getEncodedValue({
      id: amenityId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const creatAmenitySection = async (section, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(createCategorySection),
    variables: getEncodedValue({
      name: section.name,
      hotelId: hotelId,
      lang: lang,
      images: section.images,
      mediaContent: section.mediaContent,
      customAttributes: section?.customAttributes,
    }),
  });
};

export const getAmenityCategory = async (hotelId, lang) => {
  return await client.query({
    query: gql(getHotelAmenityDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const creatAmenityCategory = async (category, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createAmenitiesCategory),
    variables: getEncodedValue({
      sectionIds: category?.sectionIds,
      sectionId: category?.sectionId,
      name: category?.name,
      hotelId: hotelId,
      lang: lang,
      images: category?.images,
      mediaContent: category?.mediaContent,
      customAttributes: category?.customAttributes,
    }),
  });
};

export const updateAmenityCategory = async (category, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateAmenitiesCategory),
    variables: getEncodedValue({
      sectionIds: category?.sectionIds,
      name: category?.name,
      hotelId: hotelId,
      id: category?.id,
      lang: lang,
      images: category?.images,
      mediaContent: category?.mediaContent,
      customAttributes: category?.customAttributes,
    }),
  });
};

export const deleteAmenityCategoryAPI = async (categoryId, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAmenityCategory),
    variables: getEncodedValue({
      id: categoryId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const deleteAmenitySectionAPI = async (sectionId, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(deleteCategorySection),
    variables: getEncodedValue({
      id: sectionId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateAmenitySection = async (section, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(updateCategorySection),
    variables: getEncodedValue({
      name: section.name,
      hotelId: hotelId,
      id: section.id,
      lang: lang,
      images: section.images,
      mediaContent: section.mediaContent,
      customAttributes: section?.customAttributes,
    }),
  });
};

export const getAllRestaurantDetails = async (hotelId, lang) => {
  return await client.query({
    query: gql(getAllRestaurant),
    variables: getEncodedValue({ hotelId: hotelId, lang: lang }),
    fetchPolicy: 'network-only',
  });
};

export const getUserInviteSelectedRestaurants = async (hotelIds, lang) => {
  return await propertyServiceV5Client.query({
    query: gql(getRestaurantsByHotel),
    variables: getEncodedValue({
      hotelIds: hotelIds,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getUsers = async () => {
  return await client.query({
    query: gql(getAllUsers),
    variables: getEncodedValue({}),
    fetchPolicy: 'network-only',
  });
};

export const getDefaultRoles = async (obj) => {
  return await client.query({
    query: gql(getDefaultAdminRoles),
    variables: getEncodedValue({}),
    fetchPolicy: 'network-only',
  });
};

export const getRolePermissions = async (roleIds) => {
  return await client.query({
    query: gql(getCustomRolePermissions),
    variables: getEncodedValue({ roleIds: roleIds }),
    fetchPolicy: 'network-only',
  });
};

export const inviteNewUser = async (payload) => {
  return await client.mutate({
    mutation: gql(inviteUserReq),
    variables: getEncodedValue({
      brandId: payload.brandId,
      departmentId: payload.departmentId,
      email: payload.email,
      employeeId: payload.employeeId,
      firstName: payload.firstName,
      hotelId: payload.hotelId,
      groupId: payload.groupId,
      lastName: payload.lastName,
      phoneNumber: payload.phoneNumber,
      imageUrl: payload.imageUrl,
      roles: payload.roles,
      role: payload.role,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const editUserDetails = async (payload) => {
  return await client.mutate({
    mutation: gql(editUser),
    variables: getEncodedValue({
      brandId: payload.brandId,
      departmentId: payload.departmentId,
      employeeId: payload.employeeId,
      firstName: payload.firstName,
      hotelId: payload.hotelId,
      groupId: payload.groupId,
      lastName: payload.lastName,
      phoneNumber: payload.phoneNumber,
      imageUrl: payload.imageUrl,
      role: payload.role,
      roles: payload.roles,
      restaurantId: payload.restaurantId,
      id: payload.id,
    }),
  });
};

export const deactivateUserById = async (userId) => {
  return await client.mutate({
    mutation: gql(deactivateUser),
    variables: getEncodedValue({
      id: userId,
    }),
  });
};

export const reactivateUserById = async (userId) => {
  return await client.mutate({
    mutation: gql(reactivateUser),
    variables: getEncodedValue({
      id: userId,
    }),
  });
};

export const resendUserInvite = async (userId) => {
  return await client.mutate({
    mutation: gql(resendInvite),
    variables: getEncodedValue({
      id: userId,
    }),
  });
};

export const getUserDetails = async (id) => {
  return await client.query({
    query: gql(getUserDetailsById),
    variables: getEncodedValue({
      input: id,
    }),
    fetchPolicy: 'network-only',
  });
};

export const createRestaurant = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addRestaurant),
    variables: getEncodedValue({
      code: payload.code,
      venueGroupId: payload.venueGroupId,
      awards: payload.awards,
      description: payload.description,
      additionalInformation: payload.additionalInformation,
      type: payload.type,
      name: payload.name,
      menu: payload.menu,
      customAttributes: payload.customAttributes,
      hours: payload.hours,
      contact: payload.contact,
      contactNumber: payload.contactNumber,
      email: payload.email,
      location: payload.location,
      mediaContent: payload.mediaContent,
      videos: payload.videos,
      gifs: payload.gifs,
      images: payload.images,
      hotelId: payload.hotelId,
      primaryCuisine: payload.primaryCuisine,
      secondaryCuisine: payload.secondaryCuisine,
      menuStatus: payload.menuStatus,
      ctaTitle: payload.ctaTitle,
      cta: payload.cta,
      isActive: payload.isActive,
      cuisine: payload.cuisine,
      additionalMenu: payload.additionalMenu,
      lang: lang,
    }),
  });
};

export const updateRestaurantDetails = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateRestaurant),
    variables: getEncodedValue({
      code: payload.code,
      venueGroupId: payload.venueGroupId,
      awards: payload.awards,
      description: payload.description,
      additionalInformation: payload.additionalInformation,
      type: payload.type,
      name: payload.name,
      menu: payload.menu,
      customAttributes: payload.customAttributes,
      hours: payload.hours,
      contactNumber: payload.contactNumber,
      email: payload.email,
      contact: payload.contact,
      location: payload.location,
      mediaContent: payload.mediaContent,
      videos: payload.videos,
      gifs: payload.gifs,
      images: payload.images,
      hotelId: payload.hotelId,
      id: payload.id,
      primaryCuisine: payload.primaryCuisine,
      secondaryCuisine: payload.secondaryCuisine,
      menuStatus: payload.menuStatus,
      ctaTitle: payload.ctaTitle,
      cta: payload.cta,
      isActive: payload.isActive,
      cuisine: payload.cuisine,
      additionalMenu: payload.additionalMenu,
      lang: lang,
    }),
  });
};

export const createDataSortMapping = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(dataSortMapping),
    variables: getEncodedValue({
      hotelId: payload?.hotelId,
      jsonResponse: payload?.jsonResponse,
      module: payload?.module,
      lang: lang,
    }),
  });
};

export const updateLiveTvOrders = async (payload) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(updateLiveTvOrder),
    variables: getEncodedValue({
      hotelId: payload?.hotelId,
      channels: payload?.channels,
    }),
  });
};

export const sortChannels = async (payload) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(sortChannel),
    variables: getEncodedValue({
      hotelId: payload?.hotelId,
      isSort: payload?.isSort,
    }),
  });
};

export const createChef = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addChef),
    variables: getEncodedValue({
      restaurantId: payload.restaurantId,
      name: payload.name,
      designation: payload.designation,
      specisalisation: payload.specisalisation,
      signatureDish: payload.signatureDish,
      description: payload.description,
      email: payload.email,
      phone: payload.phone,
      images: payload.images,
      mediaContent: payload.mediaContent,
      hotelId: payload.hotelId,
      lang: lang,
    }),
  });
};

export const updateChefDetails = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateChef),
    variables: getEncodedValue({
      restaurantId: payload.restaurantId,
      name: payload.name,
      designation: payload.designation,
      specisalisation: payload.specisalisation,
      signatureDish: payload.signatureDish,
      description: payload.description,
      email: payload.email,
      phone: payload.phone,
      images: payload.images,
      mediaContent: payload.mediaContent,
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deleteChefDetails = async (hotelId, chefId, lang) => {
  return await client.mutate({
    mutation: gql(deleteChef),
    variables: getEncodedValue({
      hotelId,
      id: chefId,
      lang,
    }),
  });
};

export const deleteRestaurantDetails = async (hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deleteRestaurant),
    variables: getEncodedValue({
      hotelId,
      id: restaurantId,
      lang,
    }),
  });
};

export const getAllSpaDetails = async (hotelId, lang) => {
  return await client.query({
    query: gql(getSpaDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const createSpa = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addSpa),
    variables: getEncodedValue({
      code: payload.code,
      name: payload.name,
      description: payload.description,
      isActive: payload.isActive,
      treatmentsMenu: payload.treatmentsMenu,
      customAttributes: payload.customAttributes,
      hours: payload.hours,
      contact: payload.contact,
      location: payload.location,
      cta: payload.cta,
      images: payload.images,
      mediaContent: payload.mediaContent,
      hotelId: payload.hotelId,
      lang: lang,
    }),
  });
};

export const updateSpaDetails = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateSpa),
    variables: getEncodedValue({
      code: payload.code,
      name: payload.name,
      description: payload.description,
      isActive: payload.isActive,
      treatmentsMenu: payload.treatmentsMenu,
      customAttributes: payload.customAttributes,
      hours: payload.hours,
      contact: payload.contact,
      location: payload.location,
      cta: payload.cta,
      images: payload.images,
      mediaContent: payload.mediaContent,
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deleteSpaDetails = async (spaId, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deleteSpa),
    variables: getEncodedValue({
      id: spaId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const createSpaCategoryAPI = async (spaCategory, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(createSpaCategory),
    variables: getEncodedValue({
      name: spaCategory.name,
      code: spaCategory.code,
      spaId: spaCategory.spaId,
      hotelId: hotelId,
      images: spaCategory.images,
      mediaContent: spaCategory.mediaContent,
      customAttributes: spaCategory?.customAttributes,
      lang: lang,
    }),
  });
};

export const updateSpaCategoryAPI = async (spaCategory, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(updateSpaCategory),
    variables: getEncodedValue({
      name: spaCategory.name,
      code: spaCategory.code,
      id: spaCategory.id,
      spaId: spaCategory.spaId,
      hotelId: hotelId,
      images: spaCategory.images,
      mediaContent: spaCategory.mediaContent,
      customAttributes: spaCategory?.customAttributes,
      lang: lang,
    }),
  });
};

export const deleteSpaCategoryAPI = async (spaCategoryId, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deleteSpaCategory),
    variables: getEncodedValue({
      id: spaCategoryId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const addSpaTreatmentAPI = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addSpaTreatment),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      spaId: payload.spaId,
      spaCategoryId: payload.spaCategoryId,
      code: payload.code,
      name: payload.name,
      disclaimer: payload.disclaimer,
      redirectUrl: payload.redirectUrl,
      description: payload.description,
      isActive: payload.isActive,
      customAttributes: payload.customAttributes,
      type: payload.type,
      duration: payload.duration,
      images: payload.images,
      mediaContent: payload.mediaContent,
      lang: lang,
    }),
  });
};

export const updateSpaTreatmentAPI = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateSpaTreatment),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      spaId: payload.spaId,
      spaCategoryId: payload.spaCategoryId,
      code: payload.code,
      name: payload.name,
      disclaimer: payload.disclaimer,
      redirectUrl: payload.redirectUrl,
      description: payload.description,
      isActive: payload.isActive,
      customAttributes: payload.customAttributes,
      type: payload.type,
      duration: payload.duration,
      images: payload.images,
      mediaContent: payload.mediaContent,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deleteSpaTreatmentAPI = async (spaTreatmentId, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deleteSpaTreatment),
    variables: getEncodedValue({
      id: spaTreatmentId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const onDeleteUser = async (userId) => {
  return await client.mutate({
    mutation: gql(deleteUser),
    variables: getEncodedValue({
      id: userId,
    }),
  });
};

// start of Locations API calls
export const createNewLocation = async (location, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(createLocation),
    variables: getEncodedValue({
      type: location.type,
      name: location.name,
      description: location.description,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateLocationDetails = async (location, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(updateLocation),
    variables: getEncodedValue({
      name: location.name,
      id: location.id,
      type: location.type,
      description: location.description,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const deleteLocationDetail = async (locationId, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(deleteLocation),
    variables: getEncodedValue({
      id: locationId,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const changeSpaInfoStatus = async (hotelId, spaID, isActive, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(changeSpaStatus),
    variables: getEncodedValue({
      spaID: spaID,
      hotelID: hotelId,
      isActive: isActive,
      lang: lang,
    }),
  });
};

export const changeTreatmentInfoStatus = async (hotelId, treatmentID, isActive, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(changeSpaTreatmentStatus),
    variables: getEncodedValue({
      treatmentID: treatmentID,
      hotelID: hotelId,
      isActive: isActive,
      lang: lang,
    }),
  });
};

export const changeRestaurantStatus = async (hotelId, id, isActive) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(changeRestaurantInfoStatus),
    variables: getEncodedValue({
      hotelID: hotelId,
      id: id,
      isActive: isActive,
    }),
  });
};

export const getAllPropertyConfigs = async (hotelId) => {
  return await integrationServiceV4Client.query({
    query: gql(getSyncConfigs),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const syncSrs = async (hotelId) => {
  return await integrationServiceV3Client.mutate({
    mutation: gql(syncSRS),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
  });
};

export const updateSpaSyncConfigs = async (hotelId, isEnabled) => {
  return await integrationServiceV4Client.mutate({
    mutation: gql(updateSpaSyncConfig),
    variables: getEncodedValue({
      hotelId: hotelId,
      allowedRoles: [],
      isEnabled,
    }),
  });
};

export const syncPos = async (hotelId) => {
  return await integrationServiceV1Client.mutate({
    mutation: gql(syncPOS),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
  });
};

export const updateIRDSyncConfigs = async (hotelId, isEnabled) => {
  return await integrationServiceV4Client.mutate({
    mutation: gql(updateIRDSyncConfig),
    variables: getEncodedValue({
      hotelId: hotelId,
      allowedRoles: [],
      isEnabled,
    }),
  });
};

export const updateHKSyncConfigs = async (hotelId, isEnabled) => {
  return await integrationServiceV4Client.mutate({
    mutation: gql(updateHKSyncConfig),
    variables: getEncodedValue({
      hotelId: hotelId,
      allowedRoles: [],
      isEnabled,
    }),
  });
};

export const syncHk = async (hotelId) => {
  return await integrationServiceV1Client.mutate({
    mutation: gql(syncHK),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
  });
};

export const syncPreferences = async (hotelId) => {
  return await integrationServiceV10Client.mutate({
    mutation: gql(syncPreference),
    variables: getEncodedValue({
      hotelId: hotelId,
    }),
  });
};

export const getAllTimeZoneList = async () => {
  return await propertyServiceV6Client.query({
    query: gql(getTimeZones),
    variables: getEncodedValue({}),
    fetchPolicy: 'network-only',
  });
};

export const isSSOConfigured = async (payload) => {
  try {
    const response = await fetch(`${PROPERTY_SERVICE_URL}/sso-saml/isSSOConfigured`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': X_API_KEY,
      },
      body: JSON.stringify(payload),
    });

    return await response.json();
  } catch (error) {
    throw error;
  }
};
export const getUser2 = () => {
  let user = null;
  let tokens = {
    id_token:
      'eyJraWQiOiJZbHpQeHFMNWtFVVwvSEx6UWhDVU04bDUwQXpERDRFZnlcL0dhd0hTWVpkK1E9IiwiYWxnIjoiUlMyNTYifQ.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.Q43pRiiPMTlPN4td0P9LxwucIxQN6BlCExkN-xy_C8p3Oezeov7syhIRLEz0UznrDUkrssEaI2P9O2AOEUhYZlxdlpiBvROx6dleUTC1ndj91E7CdY1luhp9EqOKFhyX7CaUGcUr1_-1z7B6uDu6WF76U93D1mhU-iDOVCGHBEX3tiyE_JP08RZSejkc8WnYLm2v6V1q5GPSAEGKco9QWgJvetiROS4y9kUy92vGvEs5dIHUYBUvirgZ6_JO7vpeU8CGtCNE4J3yHJ3wjsYwnTz8E2RFo7r_ExJbSq_KqW0MJa7ffMQda2sxuyyCB38NQjp4aPOt2IgCVdZUKkygWw',
    access_token:
      'eyJraWQiOiJiOVgwVmYybkw0bUdcL0l3bmNiVkkwNngwVlBwclVPZjJRNDNtUUlVUzJ6QT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzNDMyMGIyZS04MmVhLTRjOTEtOTNhYi1iOTE3ZWFhOGRmMmMiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2JrakdPQ0tFYSIsInZlcnNpb24iOjIsImNsaWVudF9pZCI6IjVlNmR2M3B1MGdvNWY1ZnA1aHA0MXNnM2VkIiwib3JpZ2luX2p0aSI6ImMwYWVlNzgyLTQzNDEtNDlkYy05MDc0LWNjNjFhYjQ4NmRlNiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gcGhvbmUgb3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhdXRoX3RpbWUiOjE3NTA4MjUyNTQsImV4cCI6MTc1MDgyODg1NCwiaWF0IjoxNzUwODI1MjU0LCJqdGkiOiI1NDE1OGJmMS1kYzlmLTQwNTEtYTg5My0yMGVmYzBmYTUzOTkiLCJ1c2VybmFtZSI6Imh1ZGluaXNpbmdsZXRlbmFudF9zYWhhbC5zYWluQGh1ZGluaS5pbyJ9.PoGtcpF_Z9tvncndgABthufkjXIu0sA6IL7sMitYfpiT-L8u6rp1sh0CW2VXFxlmCephX_FcnsigQbKImMULEj44f8TQ0UX4JnltCtwcbonVpbM7cUHRrNYJHknpHiC4p_iH_U-uX-e0vMuIiUAz6LTqlvV8SnQMWh-2reWzKIch2rY5Ia0-BNfPOTNwTCk0cYDmqezGvfA-turXoYMUI8UiFfbRuGWUDlzRFYtkTqggXStYtRy7WC2uTD9Sp-qYLQB2pDdmoEp24RzH0Oxu9lhZ1JFSBU1SAX2JKNdolQtFbFEVjMhoDEbjP0MejpNZNNz7Jd4Bk0siYAcqPW8L4A',
    refresh_token:
      'eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.m9yKzBzI_gOQwJ7QBtu77M677-CJgSgvgpbO5NQ-SiqlOvXTq52siWq_gcqaNzpugQRbgqP7M-SnIkv0TEcfbqJOGJke03I1IfQfWScuJ8ILDumtor3eRhzXjZYzvXHsk2vqENashJIY5AtBdvq4trizI7DhVvPQgg4NX7dUAjuyKfDD5nM1V408k5vYsXKsj3kiA5F7QFnN6f9HPsuB9D2uaJ1wtlq7ZcmHYVDN20sxYUQ8ooY4Da9cnRj1ON70NNq_Wb8x_PozmFHCMOdhXxjbv_LRoO47JW8aW0zFhbPC-rgAVr4B6TbT6aUOGOcMGmf9xAMLFaUbKDfwMX5wmw.s_fR2hOG6kfhyusz.2pzKxCI3Ws9kJeynpciuf-F9qOz3lGA2px4-TOT_8qN6NBf4Bk5ZWXy7eMksNyidM4JULG-ASOMG-2AZt3utBnGXOgAe_TZKN6uKNr8FMgIw0dxy0WjKIi8pMIuVc-E5OVBOZrC0ioIbFWkCzGKYOdxZjGNl2UWSXZ0Ke5uhTcvGcJA0Y44b1sIeTFsSevzLLjrRpMV8ZhzKltYmrZjKE9Rh2kDEfo00zfjCuaFNB3tbbV2J6JHKX3xi-vigBndB8D7n-dO8BUTI2e7X0IHMT0m0MEcZr_5QXgo0qr50YodBSnAyM8fIdyo2zl69KRT-MNo-yUT1WIEyMRGj3glMhR0bbUy4IKxMD4a_zfrz3MSfmG300Y4oKhjYSYSlbjQYTWL2iJa9R4MlYTsRw116iPKHNFrgzvrnK9_Iy8YcZyX08XUVha-UDM_xdd-VUPMPi66eGSxsXnrkPF1YTbno1b9rbl0cPFPuMiXTy5PL6uHfj3a6G9iCNORGtlDfxrR-7CKUPkkCkb3-zyYTcrjAzLT631JSD6ZcjM4wD5NjQ-33spLxL8NpCc32BTQwQVuPevaF0zLWjqQ7oqtj5h6AHuh0pjO_Vqc_ORR8OvM6Fdm99cqJOrBVbtabnzMjJm0xHYY53TGnllFuYjvsTNtCRE34J-z2v8uviWXJrh6rLgF7EAxcfY70yI13diVOvN3pcjdw_STcjal0NlP8OrZVv3joGRPqyUc_Wh5TSDbwz5LXMLSfkjlehzzoCrtYHpPcD-GhZhiAELQw5uox6O327bT5fPqAa-7v36frPR8l71d4TrFsHfTrLgGNLPFhVUlDrqMusaSEXPPZxohOBgsLwBheMdC5uuorzEDGlsASiZit6kLF2NjcYBJa7-qiQc_4OM-MaR8ZUbNo5KTLKvFHfw65y9UFnZZQfUkszfoYAk7rUvKylK0r9sN29aM5NwIFxGBQAadcO7B0GaAGbGXcuqdMXq9X2VfaX3w-T4PFbpKnSFOKajzp4YXXgbTLSdoAMoT6aeITioaIErRul3R1ZaXKsscAFdPOOmRVsGh9urwhm-WP4LNprA9UftRyRDbQSBZVKUX8ApoStPpXuI4CGUdVAo16OD0X_uXB8kSEJFxtdJe4fBDO2XEEAigICdYacy18A_ZrAzle5aor-MPCu-qFv9Ktbr8ULbQUHMZR7vzEwqgB6kiJ4N1OwpIhucM9E9oRWtgtux0roNa70X-fC0nMpOEOlmF65HmT4U0kdV_O99T97K7DkgPwFhtiUg3Zb0TKtzhjU9MOOMlNvZLQBSGJK-zvoFco2xMozzsJB4loN1E.4a2688f36sjUj9VukpECyg',
    expires_in: 3600,
    token_type: 'Bearer',
  };
  if (tokens.id_token) {
    const decodedValue = decodeJWT(tokens.id_token);
    const metaData = JSON.parse(decodedValue['custom:meta_data']);

    user = {
      access_token: tokens.access_token,
      refresh_token: tokens.refresh_token,
      attributes: {
        email_verified: metaData?.email_verified || decodedValue?.email_verified,
        sub: decodedValue?.sub,
        given_name: metaData?.given_name || decodedValue?.given_name,
        family_name: metaData?.family_name || decodedValue?.family_name,
        email: metaData?.email || decodedValue?.email,
        userId: metaData?.userId,
        'custom:role': decodedValue['custom:role'],
        'custom:status': decodedValue['custom:status'],
        'custom:user_type': decodedValue['custom:user_type'],
      },
      signInUserSession: {
        idToken: {
          jwtToken: tokens.id_token,
        },
      },
    };
  }
  return user;
};

export const exchangeCodeForToken = async (code) => {
  let user = null;

  try {
    const redirectUri = `${window.location.origin}/prelogin`;

    if (!SSO_TOKEN_URL) {
      throw new Error('SSO_TOKEN_URL is not defined');
    }
    const response = await fetch(SSO_TOKEN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: SSO_CLIENT_ID || '',
        code,
        redirect_uri: redirectUri,
      }),
    });
    const tokens = await response.json();
    if (!response.ok) {
      throw new Error(tokens?.error_description || 'Failed to exchange code for token');
    }
    if (tokens.id_token) {
      const decodedValue = decodeJWT(tokens.id_token);
      const metaData = JSON.parse(decodedValue['custom:meta_data']);

      user = {
        access_token: tokens.access_token,
        refresh_token: tokens.refresh_token,
        attributes: {
          email_verified: metaData?.email_verified || decodedValue?.email_verified,
          sub: decodedValue?.sub,
          given_name: metaData?.given_name || decodedValue?.given_name,
          family_name: metaData?.family_name || decodedValue?.family_name,
          email: metaData?.email || decodedValue?.email,
          userId: metaData?.userId,
          'custom:role': decodedValue['custom:role'],
          'custom:status': decodedValue['custom:status'],
          'custom:user_type': decodedValue['custom:user_type'],
        },
        signInUserSession: {
          idToken: {
            jwtToken: tokens.id_token,
          },
        },
      };
    }
  } catch (error) {
    console.error('Error exchanging code for token:', error);
  }

  return user;
};

export const convertUserToCognitoFormat = (user) => {
  const attributes = user.attributes;

  const cognitoAttributes = Object.entries(attributes)
    .filter(([key, value]) => key !== 'userId' && value !== undefined && value !== null)
    .map(([key, value]) => ({
      Name: key,
      Value: String(value),
    }));

  return {
    UserAttributes: cognitoAttributes,
    Username: String(attributes.userId),
  };
};

export const propertyServiceV7Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V7_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V7_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const enableMFA = async (userIds, MfaEnforced) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(enableMFAConfig),
    variables: getEncodedValue({
      userIds,
      MfaEnforced,
    }),
  })
}